// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f3949f23","952":"6211c013"}[chunkId] + ".chunk.js";
};